"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.websiteTheme = void 0;
const component_theme_1 = require("@clds/component-theme");
const { palette } = component_theme_1.globalTheme;
const { brand } = component_theme_1.globalTheme.palette;
exports.websiteTheme = (0, component_theme_1.createTheme)({
    headlines: {
        fontFamily: 'sofia-pro',
        xxxxl: {
            fontSize: '64px',
            lineHeight: '64px',
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: brand.darkBlue,
                fontWeight: 'bold',
            },
        },
        xxxl: {
            fontSize: '46px',
            lineHeight: 'normal',
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: brand.darkBlue,
                fontWeight: 'bold',
            },
        },
        xl: {
            fontSize: '28px',
            lineHeight: 'normal',
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: brand.darkBlue,
                fontWeight: 'bold',
            },
        },
        lg: {
            fontSize: '18px',
            lineHeight: '1.5',
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'normal',
            },
            bold: {
                color: brand.darkBlue,
                fontWeight: 'normal',
            },
        },
        md: {
            fontSize: '16px',
            lineHeight: '1.69',
            contrastInvertBold: {
                color: palette.contrastInvert,
                fontWeight: 'bold',
            },
            bold: {
                color: brand.darkBlue,
                fontWeight: 'bold',
            },
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'normal',
            },
            regular: {
                color: brand.darkBlue,
                fontWeight: 'normal',
            },
        },
        sm: {
            fontSize: '14px',
            lineHeight: '1.93',
            bold: {
                color: brand.darkBlue,
                fontWeight: 'bold',
            },
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'normal',
            },
        },
    },
    brandText: {
        fontFamily: 'Inter',
        lg: {
            fontSize: '18px',
            lineHeight: '1.5',
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'normal',
            },
            bold: {
                color: brand.darkBlue,
                fontWeight: 'normal',
            },
            regular: {
                color: brand.darkBlue,
                fontWeight: 'normal',
            },
        },
        sm: {
            fontSize: '14px',
            lineHeight: '1.93',
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'normal',
            },
            bold: {
                color: brand.darkBlue,
                fontWeight: 'bold',
            },
            accentCoral: {
                color: brand.accentCoral,
                fontWeight: 'bold',
            },
        },
        xs: {
            fontSize: '12px',
            lineHeight: '2.25',
            contrastInvert: {
                color: palette.contrastInvert,
                fontWeight: 'normal',
            },
            regular: {
                color: brand.darkBlue,
                fontWeight: 'normal',
            },
        },
    },
});
//# sourceMappingURL=websiteTheme.js.map